var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4281 2.77309C10.9155 2.26053 10.0845 2.26053 9.57192 2.77309L0.848461 11.4966C0.59218 11.7528 0.59218 12.1684 0.848461 12.4246C1.10474 12.6809 1.52026 12.6809 1.77654 12.4246L10.5 3.70117L19.2235 12.4246C19.4797 12.6809 19.8953 12.6809 20.1515 12.4246C20.4078 12.1684 20.4078 11.7528 20.1515 11.4966L17.0625 8.40752V4.08559C17.0625 3.72316 16.7687 3.42934 16.4062 3.42934H15.0938C14.7313 3.42934 14.4375 3.72316 14.4375 4.08559V5.78252L11.4281 2.77309Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.12627L18.375 13.0013V18.5231C18.375 19.6104 17.4936 20.4918 16.4062 20.4918H4.59375C3.50644 20.4918 2.625 19.6104 2.625 18.5231V13.0013L10.5 5.12627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseFill);
export default __webpack_public_path__ + "static/media/house-fill.fbde8bba28c5c5c6e85181b7485f5bdc.svg";
export { ForwardRef as ReactComponent };